module.exports = __webpack_public_path__ + "images/category_lp/smartphone/banner_c17f45be030bb713520a4c473b292e43.png";